/* eslint-disable max-classes-per-file */

import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IDepartment } from '../models/department.model';

export class LoadDepartments {
  static readonly type = '[Department] Fetch Departments';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllDepartments {
  static readonly type = '[Department] Fetch All Departments';
  constructor(
    public excludeArchived: boolean = true,
    public onlyVessels?: boolean
  ) {}
}

export class LoadDepartmentsAccessedByEmployment {
  static readonly type = '[Department] Fetch All Departments Accessed By Employment';
  constructor() {}
}

export class LoadAllDepartmentsForSelectedTenant {
  static readonly type = '[Department] Fetch All Departments For Selected Tenant';
  constructor(
    public tenantId: string,
    public excludeArchived: boolean = true
  ) {}
}

export class LoadAllDepartmentsForMenuId {
  static readonly type = '[Department] Fetch All Departments For Menu Id';
  constructor(
    public menuId: string,
    public excludeArchived: boolean = true
  ) {}
}

export class LoadDepartmentsForUser {
  static readonly type = '[Department] Fetch Departments For User';
  constructor(public excludeArchived: boolean = true) {}
}

export class LoadUsersForSelectedDepartment {
  static readonly type = '[Department] Fetch Users for currently selected Department';
  constructor(
    public config: { onlyEmployed?: boolean; includeDeleted?: boolean } = {
      onlyEmployed: false,
      includeDeleted: false,
    }
  ) {}
}

export class LoadUsersForDepartment {
  static readonly type = '[Department] Fetch Users for specific Department';
  constructor(
    public departmentId: string,
    public config: { onlyEmployed?: boolean; includeDeleted?: boolean } = {
      onlyEmployed: false,
      includeDeleted: false,
    }
  ) {}
}

export class LoadDepartmentById {
  static readonly type = '[Department] Load Department By Id';
  constructor(public id: string) {}
}

export class LoadDepartmentOptions {
  static readonly type = '[Department] load Department Options';
}

export class LoadDepartmentList {
  static readonly type = '[DepartmentList] load DepartmentList';
  constructor(public excludeArchived: boolean = false) {}
}

export class CreateDepartment {
  static readonly type = '[Department] Create Department';
  constructor(public department: IDepartment) {}
}

export class UpdateDepartment {
  static readonly type = '[Department] update Department';
  constructor(public department: IDepartment) {}
}

export class DeleteDepartment {
  static readonly type = '[Department] Delete Department';
  constructor(public departmentId: string) {}
}

export class ClearCurrentDepartment {
  static readonly type = '[Department] Clear Current Department';
}
